<template>
<!--  <div id="backend_nav_wrapper" class="relative w-100">
    <div id="backend_left_nav" class="float_left">
        <md-button @click="openNewClient" class="md-raised secondary">
          Neuer Kunde
        </md-button>
        <md-button @click="openNewEvent" class="md-raised secondary">
          Neue Veranstaltung
        </md-button>
    </div>
    <div id="backend_right_nav" class="float_right">
      <md-menu class="user_menu" md-direction="bottom-end">
        <md-button class="user_top_link" md-menu-trigger><i v-if="options.user.pic" class="userPic" :style="'background-image: url('+ options.user.pic +');'"></i><span class="inline_block left"><span class="bold">{{options.user.firstname + ' ' + options.user.lastname}}</span><br/><span>{{ options.user.role == 1 ? 'Admin' : 'Mitarbeiter' }}</span></span><md-icon class="inline_block">expand_more</md-icon></md-button>
        <md-menu-content>
          <md-menu-item title="Account" class="md-icon-button mt-7" @click="myAccount"><md-icon>person_outline</md-icon>Benutzerkonto</md-menu-item>
          <md-menu-item title="Logout" class="md-icon-button mt-7" @click="logMeOut"><md-icon>power_settings_new</md-icon>Logout</md-menu-item>
        </md-menu-content>
      </md-menu>
    </div>
  </div>-->
  <div></div>
</template>

<script>
export default {
  name: 'BackendNavi',
  props: {
    options: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
    }
  },
  created() {
    if(this.options.user.id === undefined){
      //console.log(this.options.user);
      // console.log("user")
    }
  },
  mounted() {
    if (!this.options.user.loggedIn) {
      this.options.noNav = true;
      this.$router.push('/signin');
    } else {
      this.options.noNav = false;
    }
  },
  methods: {
    logMeOut() {
      this.logout();
    },
    openNewClient(){
      this.options.currentClient = null;
      this.options.showClientForm = true;
    },
    openNewEvent(){
      this.options.currentEvent = null;
      this.options.showEventForm = true;
    },
    myAccount(){
      this.options.user.itsMe = true;
      this.options.currentFormUser = this.options.user;
      this.options.showUserForm = true;
    }
  }
}
</script>
